import React, { useState, useRef, useEffect } from 'react';
import { FooterModal } from "components/common/modal/Footer";
import { Body } from "components/common/modal/Body";
import { HeaderModal } from "components/common/modal/Header";

import allImgPaths from "assets/images";
import CustomSelect from 'components/common/CustomSelect';
import CustomCheckBox from 'components/CustomCheckBox';
import useAppState from 'context/useAppState';
import Select, { SingleValue } from "react-select";
import { addFileHistoryData, fileUploadExtraction, fileUploadList, getEventTaskList } from 'services/event';
import { useParams } from 'react-router-dom';
import { llmAgentInstruction, llmCreateRAG } from 'services/llm';
import { extractJSONFromText, formatFileSize, jsonToMarkdown } from 'utils/function';
import { customSelectStyle } from 'utils/style';
import { generatePresignedUrl, uploadFileToS3 } from 'services/auth/auth';
import { ALLOWED_FILE_MIME_TYPES, DOCUMENTS_BUCKET_NAME, DOCUMENT_ROUTE_PREFIX, MAX_FILE_SIZE } from 'utils/constant';
import { Modal } from 'components/common/modal/Modal';
import { getLLMAgentInstructPayload, getLLMAgentRAGCreatePayload } from 'services/llm/payloads';
import * as XLSX from 'xlsx';
import { clone, cloneDeep } from 'lodash';
import Toast from 'components/common/Toast';

type taskDropDown = {
    value: string;
    label: string;
};

const fileUploadOptionInit: any = [
    {
        name: 'Upload New',
        value: 'new'
    },
    {
        name: 'Merge with Existing',
        value: 'merge'
    }
]

const UploadFileModal = () => {
    const { showUploadFileModal, setState: setChatBoxState } = useAppState('chatBox');
    const { selectedCardDetail } = useAppState('cardWrapper')
    const { draftEvent } = useAppState('newFeteChat')
    const actualBtnRef = useRef<any>(null);
    const params: any = useParams();
    const [fileList, setFileList] = useState<any>([]);
    const [dropDownOptions, setDropDownOptions] = useState<taskDropDown[]>([]);
    const [taskDropDownValue, setTaskDropDownValue] = useState<taskDropDown | null>();
    const [progressMap, setProgressMap] = useState<any>({});
    const [isRequesting, setIsRequesting] = useState(false);
    const { setState: setEventDataState, bestActionPrompt } = useAppState('eventData');
    const [extractedData, setExtractedData] = useState<any>([]);
    const [extractedDataKeys, setExtractedDataKeys] = useState<any>([]);
    const [isShowTable, setIsShowTable] = useState(false)
    const [editKeyIndex, setEditKeyIndex] = useState<any>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const [s3Filename, setS3Filename] = useState<any>(null)
    const [taskInfo, setTaskInfo] = useState<any>(null);
    const [showOptions, setShowOptions] = useState(false)
    const [fileUploadOption, setFileUploadOption] = useState<any>(fileUploadOptionInit)
    const [previousFileList, setPreviousFileList] = useState<any>([])
    const [extractType, setExtractType] = useState(fileUploadOption[0].value);
    const [selectedMergingFileName, setSelectedMergingFileName] = useState<any>(null);
    const [errorMessage, setErrorMessage] = useState<any>(null);

    const [uploadedFileInfo, setUploadedFileInfo] = useState<any>(null)
    const [preSignedObjInfo, setPreSignedObjInfo] = useState<any>(null)

    const userData = JSON.parse(localStorage.getItem('userData') as string)
    const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

    useEffect(() => {
        if (showUploadFileModal && selectedCardDetail) {
            const { columnId: block_id, id } = selectedCardDetail;

            (async () => {
                const { data } = await getEventTaskList(params?.id, block_id, id);

                const modifiedOptions = data[0].tasks.map((task: any) => ({
                    value: task._id,
                    label: task.title,
                }));

                // Add "Main" option
                modifiedOptions.unshift({ value: "main", label: "Main" });

                setDropDownOptions(modifiedOptions);

                const taskId = taskDropDownValue?.value ? taskDropDownValue?.value : (bestActionPrompt?.task_id ? bestActionPrompt.task_id : null);
                const taskName = taskDropDownValue?.label ? taskDropDownValue.label : (bestActionPrompt?.task_name ? bestActionPrompt.task_name : null);
                setTaskDropDownValue({
                    label: taskName, value: taskId
                })
            })();
        }
    }, [showUploadFileModal]);

    const handleChange = (selectedFiles: FileList) => {
        const filesArray: any = Array.from(selectedFiles).filter((file: any) => file.size < MAX_FILE_SIZE && ALLOWED_FILE_MIME_TYPES.includes(file.type));
        const newFilesArr = [...fileList, ...filesArray]
        setFileList(newFilesArr);
        const initialProgressMap: any = {};
        newFilesArr?.forEach((file: any) => {
            initialProgressMap[file.name] = 0;
        });
        setProgressMap(initialProgressMap);
    }

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        handleChange(droppedFiles);
    }

    const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    }

    const onCloseModal = () => {
        setFileList([])
        setChatBoxState({ showUploadFileModal: false });
    }

    const handleDropDownChange = (selectedValue: SingleValue<taskDropDown>) => {
        if (selectedValue !== null) {
            setTaskDropDownValue(selectedValue);
        }
    };

    const resetStateToDefaults = () => {
        setChatBoxState({ showUploadFileModal: false });
        setProgressMap({});
        setFileList([]);
        setIsRequesting(false)
    }

    const getPresignedURL = async (file: any) => {
        try {
            const { data } = await generatePresignedUrl({
                file_name: file.name,
                content_type: file.type,
                category: "document",
                event_id: draftEvent?._id || params?.id,
                user_id: userData?.id,
                team_id: currentTeam?.currentTeamId
            });
            return data;
        } catch (error) {
            console.log('getPreSignedUrlError:: ', error);
        }
    }

    const getMetadataForCreateRAGPayload = () => {
        const metadata_payload: any = {
            "userId": userData?.id,
            "teamId": currentTeam?.currentTeamId,
            "eventId": params?.id || draftEvent?._id,
        }
        if (params?.id) {
            metadata_payload['is_draft'] = false;
        } else {
            metadata_payload['is_draft'] = true;
        }
        if (selectedCardDetail) {
            // metadata_payload['blockId'] = selectedCardDetail?.block_id;
            metadata_payload['blockId'] = selectedCardDetail?.columnId || selectedCardDetail?.block_id;
            metadata_payload['cardId'] = selectedCardDetail?.id
        }
        return metadata_payload;
    }

    const initiateS3UploadWithPresignedURL = async (file: any, presigedURLObj: any) => {
        // Set dropdown values by default
        const taskId = taskDropDownValue?.value ? taskDropDownValue?.value : (bestActionPrompt?.task_id ? bestActionPrompt.task_id : null);
        const taskName = taskDropDownValue?.label ? taskDropDownValue.label : (bestActionPrompt?.task_name ? bestActionPrompt.task_name : null);
        setTaskInfo({
            taskId, taskName
        })

        setS3Filename(presigedURLObj?.fileName)

        if (taskName && taskName.toLowerCase() == 'create attendee list') {
            const extractedData = await extractFileData(file);
            if (extractedData && extractedData?.length) {
                await callInstructAPI(extractedData)
            }
        } else {
            const response = await s3UploadAPI(file, presigedURLObj)

            if (response?.status === 200) {
                await llmCreateRAG(getLLMAgentRAGCreatePayload({
                    file_path: `s3://${DOCUMENTS_BUCKET_NAME}/${DOCUMENT_ROUTE_PREFIX}/${presigedURLObj?.fileName}`,
                    metadata: getMetadataForCreateRAGPayload(),
                }))

                await addHistory(file, presigedURLObj)

                const fileUploadExtractionPayload = {
                    event_id: params.id,
                    file_name: presigedURLObj?.fileName,
                    task_id: taskId,
                    task_name: taskName,
                    extracted_data: extractedData || [],
                    original_file_name: file?.name || null
                }
                await fileUploadExtraction(fileUploadExtractionPayload)
            } else {
                Toast.error('', 'Failed to upload file')
            }
 
            setEventDataState({ bestActionPrompt: null })

            // Reset task data, if selected
            setTaskDropDownValue(null)
        }
    }

    const s3UploadAPI = async (file: any, presigedURLObj: any) => {
        try {
            const response = await uploadFileToS3({
                url: presigedURLObj.url,
                file: file,
                type: file.type
            })
            return response
        } catch (error) {
            throw null
        }
    }

    const addHistory = async (file: any, presigedURLObj: any) => {
        const historyPayload: any = {
            eventId: params?.id || draftEvent?._id,
            content: {
                s3Filename: presigedURLObj?.fileName,
                category: 'document',
                file: {
                    lastModified: file.lastModified,
                    name: file.name,
                    size: file.size,
                    type: file.type
                }
            }
        }
        if (taskDropDownValue?.value) historyPayload['taskId'] = taskDropDownValue.value;

        await addFileHistoryData(historyPayload);
    }

    const uploadFile = async (file: any) => {
        try {
            setUploadedFileInfo(file)
            setErrorMessage(null)
            // Simulate a delay (e.g., 5 seconds) for the request
            const delaySeconds = 5;
            const startTime = new Date().getTime();

            while (new Date().getTime() - startTime < delaySeconds * 1000) {
                const elapsedTime = new Date().getTime() - startTime;
                const calculatedProgress = Math.min(Math.floor((elapsedTime / (delaySeconds * 1000)) * 100), 100);
                // setProgress(calculatedProgress);
                setProgressMap((prevProgressMap: any) => ({
                    ...prevProgressMap,
                    [file.name]: calculatedProgress,
                }));
                await new Promise(resolve => setTimeout(resolve, 100)); // Update progress every 100 milliseconds
            }
            const presigedURLObj = await getPresignedURL(file)
            if (presigedURLObj) {
                setPreSignedObjInfo(presigedURLObj)
                await initiateS3UploadWithPresignedURL(file, presigedURLObj)
            }
        } catch (error) {
            console.log('UPLOAD FILE ERR :: ', error);
            Toast.error('', 'Failed to upload file')
        }
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsRequesting(true);
        const uploadPromises = fileList.map((file: any) => uploadFile(file));
        await Promise.all(uploadPromises);
        resetStateToDefaults()
    }

    const getProgressbar = (file: any) => {
        return (
            <>
                <span
                    className="bg-[#1E0AF5] h-2 rounded-full transform transition-all duration-1000"
                    style={{ width: progressMap[file.name] > 0 ? `${progressMap[file.name]}%` : '' }}
                ></span>
                <span className='font-interMedium text-sm text-[#344054]'>{progressMap[file.name] > 0 ? `${progressMap[file.name]}%` : ''}</span>
            </>
        )
    }

    const getDocumentIcon = (file: any) => {
        let icon;
        switch (file.type) {
            case 'application/pdf':
                icon = allImgPaths.fileTypePdfIcon
                break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                icon = allImgPaths.fileTypeDOCXIcon
                break;
            case 'text/csv':
                icon = allImgPaths.fileTypeCSVIcon
                break;
            case 'text/plain':
                icon = allImgPaths.fileTypeTXTIcon
                break;
            default:
                icon = allImgPaths.fileTypeXLSXIcon
                break;
        }
        return icon;
    }

    const callInstructAPI = async (extractedData: any) => {
        const { data } = await llmAgentInstruction(getLLMAgentInstructPayload({
            prompt_key: 'FILE_DATA_EXTRACT_PROMPT',
            input_variables: {
                "context": jsonToMarkdown(extractedData)
            }
        }));

        const jsonData: any = extractJSONFromText(data?.text);

        console.log({ jsonData })
        if (jsonData?.content?.length) {
            const allKeys = Object.keys(jsonData.content[0]);

            let fileKeys: any = []
            allKeys.map((ak: any) => {
                fileKeys.push({ key: ak, selected: true })
            })
            setExtractedData(jsonData.content);
            setExtractedDataKeys(fileKeys)
            setIsShowTable(true)
        }

        console.log({ data })
    }

    // For showing modal of extracted attendee list data
    const extractFileData = (file: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            if (file) {
                const reader = new FileReader();

                reader.onload = (e: any) => {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        const json = XLSX.utils.sheet_to_formulae(worksheet);
                        resolve(json)
                    } catch (error) {
                        reject(error);
                    }
                };

                reader.onerror = (error) => reject(error);

                reader.readAsArrayBuffer(file);
            } else {
                resolve(null);
            }
        });
    };

    const editKey = (index: number) => {
        setEditKeyIndex(index)
    }

    const handleSelectKey = (index: number, isChecked: boolean) => {
        console.log(isChecked, index);
        const allKeys = cloneDeep(extractedDataKeys);
        allKeys[index]['selected'] = isChecked;
        setExtractedDataKeys(allKeys);
    }

    const handleUpdate = (index: number, value: any) => {
        if (value) {
            const allKeys = cloneDeep(extractedDataKeys);

            // To avoid key duplications
            const isKeyExists = allKeys.some((ak: any) => ak.key.toLowerCase() == value.toLowerCase())
            const isKeyExistsIndex = allKeys.findIndex((ak: any) => ak.key.toLowerCase() == value.toLowerCase())

            if (isKeyExists && index != isKeyExistsIndex) {
                return
            }

            // To update column names except the below excludedKeys ones
            const excludedKeys = ['first name', 'last name', 'email'];
            if (!excludedKeys.includes(allKeys[index]['key'])) {
                let clonedExtractedData = cloneDeep(extractedData);

                const oldKey = allKeys[index]['key']
                const newKey = value.toLowerCase();

                clonedExtractedData = clonedExtractedData.map((item: any) => {
                    const { [oldKey]: oldValue, ...rest } = item;
                    return { [newKey]: oldValue, ...rest };
                });

                setExtractedData(clonedExtractedData)
                allKeys[index]['key'] = value.toLowerCase();
            }
            setExtractedDataKeys(allKeys)
            setEditKeyIndex(null)
        }
    }

    const confirmContent = async () => {
        console.log({ extractedData, extractedDataKeys })
        setErrorMessage(null);

        // To validate that first name and email should exists in the data
        const isValid = extractedData.every((item: any) => item['first name'] && item.email);
        console.log({ isValid })
        if (!isValid) {
            setErrorMessage('Both first name and email values should exists')
            return
        }

        // To filter out or remove the columns which are not selected
        const keysToRemove = extractedDataKeys.filter((ed: any) => !ed.selected).map((ed: any) => ed.key);
        const updatedData = cloneDeep(extractedData).map((item: any) => {
            const entries = Object.entries(item);
            const filteredEntries = entries.filter(([key]) => !keysToRemove.includes(key));
            return Object.fromEntries(filteredEntries);
        });
        console.log({ updatedData })

        setIsShowTable(false);

        const response = await s3UploadAPI(uploadedFileInfo, preSignedObjInfo)
        if (response.status === 200) {
            await llmCreateRAG(getLLMAgentRAGCreatePayload({
                file_path: `s3://${DOCUMENTS_BUCKET_NAME}/${DOCUMENT_ROUTE_PREFIX}/${preSignedObjInfo?.fileName}`,
                metadata: getMetadataForCreateRAGPayload(),
            }))

            await addHistory(uploadedFileInfo, preSignedObjInfo)

            const fileUploadExtractionPayload = {
                event_id: params.id,
                file_name: s3Filename,
                task_id: taskInfo?.taskId,
                task_name: taskInfo?.taskName,
                extracted_data: updatedData || [],
                list_type: 'attendee',
                extract_type: extractType,
                merging_filename: selectedMergingFileName || null,
                original_file_name: getOriginalFileName(s3Filename)
            }

            try {
                await fileUploadExtraction(fileUploadExtractionPayload)
                setExtractedData([])
                setExtractedDataKeys([])
                setEventDataState({ bestActionPrompt: null })
                setTaskDropDownValue(null)
                setUploadedFileInfo(null)
                setPreSignedObjInfo(null)
                Toast.success('', 'Data added sucessfully')
            } catch (error) {
                Toast.error('', 'Failed to add data')
            }
        } else {
            Toast.error('', 'Failed to add data')
        }
    }

    const getOriginalFileName = (text: string) => {
        if (text) {
            const rem = text.split('_').shift();
            return text.replace(rem + '_', '');
        }
        return null
    }

    // Content starts, where file merging is done
    useEffect(() => {
        const checkList = async () => {
            if (taskDropDownValue?.label) {
                const result = await getAllList(taskDropDownValue?.label)
                setShowOptions(result)
            }
        };

        checkList();

    }, [taskDropDownValue])

    const getAllList = async (taskname: any) => {
        if (taskname?.toLowerCase() == 'create attendee list') {
            const { data } = await fileUploadList({ event_id: params.id })
            if (data?.length) {
                setPreviousFileList(data)
                setSelectedMergingFileName(data[0]?.file_name)
                return true
            } else {
                return false
            }
        }
        return false
    }

    const handleOptionChange = (event: any) => {
        const value = event.target.value
        setExtractType(value);
        if (value == 'new') {
            setSelectedMergingFileName(null)
        } else {
            setSelectedMergingFileName(previousFileList[0]?.file_name)
        }
    };

    const handleMergeOptionChange = (event: any) => {
        setSelectedMergingFileName(event.target.value);
    };

    return (
        <>
            {
                isShowTable &&
                <Modal className={"modal-wrapper max-w-[1292px]"} isShow={true}>
                    <HeaderModal
                        title=""
                        isShowHeader={true}
                        className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex justify-center items-center gap-x-4">
                                <img className="top-0.5 left-0 object-contain -z-10" src={allImgPaths.uploadFileIcon} alt="" />
                                <div className="">
                                    <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                                        Upload File
                                    </h2>
                                    <p className='text-sm text-[#475467]'>Preview your data, choose the columns to include and rename them as needed.
                                    </p>
                                </div>
                            </div>
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#F2F4F7] rounded w-5 p-1 -mt-6"
                                id="modal-toggle"
                                src={allImgPaths.closeIcon}
                                onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>
                    </HeaderModal>
                    <Body title="" isShowBody={true} className="modal-body px-6 pt-5 mb-6">
                        <div className="overflow-x-auto">
                            <div className="custom-table-grid-attendee-upload whitespace-nowrap">
                                {
                                    extractedDataKeys?.length > 0 && extractedDataKeys.map((edk: any, kIndex: number) => (
                                        <div key={kIndex} className="flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r first-of-type:rounded-tl-lg last-of-type:rounded-tr-lg first-of-type:min-w-[180px] [&:nth-child(2)]:min-w-[180px]">
                                            {
                                                editKeyIndex != kIndex &&
                                                <span className='font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center'>
                                                    {
                                                        editKeyIndex != kIndex &&
                                                        <>
                                                            {
                                                                (edk.key != 'first name' && edk.key != 'last name' && edk.key != 'email') &&

                                                                <CustomCheckBox
                                                                    name={edk.key}
                                                                    label=''
                                                                    checked={edk?.selected || false}
                                                                    onChange={(name: string, isChecked: boolean) =>
                                                                        handleSelectKey(kIndex, isChecked)
                                                                    }
                                                                />

                                                            }
                                                            <span title='Click to Update' onClick={() => editKey(kIndex)} className='font-interMedium text-sm text-[#475467] cursor-pointer truncate max-w-40'>
                                                                {edk.key}
                                                            </span>
                                                            {/* {
                                                                (edk.key != 'first name' && edk.key != 'last name' && edk.key != 'email') && edk?.selected &&
                                                                <img className='w-6 h-6 p-1 cursor-pointer on-hover-bg-blue rounded' src={allImgPaths.EditIcon} alt="" onClick={() => editKey(kIndex)} />
                                                            } */}

                                                        </>
                                                    }
                                                </span>
                                            }


                                            {
                                                editKeyIndex == kIndex &&
                                                <div className='flex py-2 px-2 items-center gap-x-2'>
                                                    <input ref={inputRef} className="border rounded w-[170px] py-0.5 px-2" type="text" defaultValue={edk.key}
                                                        onBlur={() => {
                                                            if (inputRef.current) {
                                                                handleUpdate(kIndex, inputRef.current.value);
                                                            }
                                                        }} />
                                                    <img
                                                        className='w-6 h-6 p-1 hover:bg-[#bbe1bb] cursor-pointer rounded'
                                                        src={allImgPaths.RightCheckGreenIcon}
                                                        alt=""
                                                        onClick={() => {
                                                            if (inputRef.current) {
                                                                handleUpdate(kIndex, inputRef.current.value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>

                                    ))
                                }
                            </div>
                            <div className="max-h-[calc(100vh_-_440px)]">
                                {
                                    extractedData?.length > 0 && extractedData.slice(0, 5).map((edv: any, rowIndex: number) => (
                                        <div key={rowIndex} className="custom-table-grid-attendee-upload">
                                            {
                                                extractedDataKeys.map((edk: any, colIndex: number) => (
                                                    <div key={colIndex} className="min-w-[220px] flex items-center py-3 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r first-of-type:min-w-[180px] [&:nth-child(2)]:min-w-[180px]">
                                                        <span title={edv[edk.key]} key={`${colIndex}_${rowIndex}`} className="whitespace-nowrap text-sm text-gray-900 truncate max-w-52">
                                                            {edv[edk.key]}
                                                        </span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </Body>
                    <FooterModal title="" isShowFooter={true} className="modal-footer pt-5 px-6 pb-5 border-t border-[#EAECF0]">
                        <div className="flex items-center gap-x-3 justify-end">
                            <button onClick={() => setIsShowTable(false)} className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base hover:border-[#1E0AF5]">Cancel</button>
                            <button
                                type='button'
                                onClick={() => confirmContent()}
                                className="!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5">
                                Upload
                            </button>
                        </div>
                        {
                            errorMessage &&
                            <div className='mt-5 text-[red]'>
                                {errorMessage}
                            </div>
                        }
                    </FooterModal>
                </Modal>
            }

            <Modal className={"modal-wrapper max-w-[480px]"} isShow={showUploadFileModal}>
                <form onSubmit={handleSubmit}>
                    <HeaderModal
                        title=""
                        isShowHeader={true}
                        className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex justify-center items-center gap-x-4">
                                <img className="top-0.5 left-0 object-contain -z-10" src={allImgPaths.uploadFileIcon} alt="" />
                                <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                                    Upload File
                                </h2>
                            </div>
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#F2F4F7] rounded w-5 p-1 -mt-6"
                                id="modal-toggle"
                                src={allImgPaths.closeIcon}
                                onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>
                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body px-6 pt-5">
                        <div className='' onDrop={handleDrop} onDragOver={onDragOver}>
                            <input
                                type="file"
                                id="actual-btn"
                                ref={actualBtnRef}
                                onChange={(e: any) => handleChange(e.target.files)}
                                hidden
                                // accept=".pdf, .docx, .csv, .txt, .xls, .xlsx"
                                accept={selectedCardDetail?.title?.toLowerCase() == 'attendees' ? '.xls, .xlsx' : '.pdf, .docx, .csv, .txt, .xls, .xlsx'}
                            // multiple
                            />
                            <label className='file-upload block border border-[#EAECF0] hover:border-[#786CF9] rounded-xl py-4 px-6 text-center mb-6 cursor-pointer' htmlFor="actual-btn">
                                <img className='mb-3 mx-auto' src={allImgPaths.uploadFileIcon3} alt="" />
                                <div className="">
                                    <span className='text-sm text-[#1E0AF5] font-interSemiBold'>Click to upload</span>
                                    <span className='text-sm text-[#475467]'> or drag and drop</span>
                                    {
                                        selectedCardDetail?.title?.toLowerCase() == 'attendees' &&
                                        <p className='text-sm text-[#475467]'>XLS (max. 10 MB)</p>
                                    }
                                    {
                                        selectedCardDetail?.title?.toLowerCase() != 'attendees' &&
                                        <p className='text-sm text-[#475467]'>PDF, TXT, DOC or XLS (max. 10 MB)</p>
                                    }
                                </div>
                            </label>

                            {fileList.length > 0 && (
                                <>
                                    {fileList.map((file: any, index: any) => (
                                        <div className="block border-2 border-[#EAECF0] rounded-xl py-3.5 px-3.5 mb-5" key={index}>
                                            <div className="flex gap-x-3 items-start">
                                                <img src={getDocumentIcon(file)} alt="" />
                                                <div className="w-full">
                                                    <div className="w-full">
                                                        <p className='text-sm text-[#475467]'>{file.name}</p>
                                                    </div>
                                                    <p className='text-sm text-[#475467]'>{formatFileSize(file.size)}</p>
                                                    <div className="flex items-center gap-x-2">
                                                        {isRequesting && getProgressbar(file)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {selectedCardDetail && (
                                        <>
                                            <div className="relative w-full pt-1 mb-6">
                                                <p className="text-[#344054] text-sm font-interMedium pb-2">Apply to task</p>
                                                {dropDownOptions?.length > 0 ? (
                                                    <Select
                                                        value={taskDropDownValue}
                                                        onChange={handleDropDownChange}
                                                        options={dropDownOptions}
                                                        isSearchable={true}
                                                        placeholder="Select"
                                                        className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] modal-select-box fete-settings-modals"
                                                        classNamePrefix="select"
                                                        styles={customSelectStyle}
                                                        // menuIsOpen={true}
                                                    />
                                                ) : (
                                                    <p>Loading options...</p>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    {/* Error Box */}
                                    {/* <div className="mb-5 border border-[#D0D5DD] rounded-xl py-4 px-4 bg-white shadow-sm flex flex-shrink-0 items-start gap-x-2.5">

                                        <img src={allImgPaths.alertIconSaffron} alt="" />

                                        <div className="">
                                            <p className='text-sm font-interSemiBold text-[#344054] pb-1'>There is a problem with the uploaded file</p>
                                            <p className='text-sm text-[#475467] pb-3'>
                                            We could not detect name/email or both. Name and Email address are mandatory for an attendee list.
                                            </p>
                                            <p className='text-sm text-[#475467]'>Please upload a different file.</p>
                                        </div>

                                    </div> */}
                                    {/* {
                                        taskDropDownValue?.label?.toLowerCase() == 'create attendee list' && showOptions &&
                                        <div className="p-4">
                                            {fileUploadOption.map((option: any, index: number) => (
                                                <div key={index} className="flex items-center mb-2">
                                                    <input
                                                        type="radio"
                                                        id={option.value}
                                                        name="fileUploadOption"
                                                        value={option.value}
                                                        checked={extractType === option.value}
                                                        onChange={handleOptionChange}
                                                        className="mr-2"
                                                    />
                                                    <label htmlFor={option.value} className="text-gray-700">
                                                        {option.name}
                                                    </label>
                                                </div>
                                            ))}

                                            {extractType === 'merge' && (
                                                <div className="mt-4">
                                                    <label htmlFor="mergeSelect" className="text-gray-700 mb-2 block">
                                                        Select an option to merge with:
                                                    </label>
                                                    <select
                                                        id="mergeSelect"
                                                        value={selectedMergingFileName}
                                                        onChange={handleMergeOptionChange}
                                                        className="block w-full p-2 border border-gray-300 rounded"
                                                    >
                                                        <option value="" disabled>Select an option</option>
                                                        {previousFileList.map((option: any) => (
                                                            <option key={option.file_name} value={option.file_name}>
                                                                {option.file_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                        </div>
                                    } */}
                                </>
                            )}
                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer pt-4 px-6 pb-4 border-t border-[#EAECF0]">
                        <div className="flex items-center gap-x-3 justify-end">
                            <button onClick={onCloseModal} className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base hover:bg-[#F2F4F7] w-40">Cancel</button>
                            <button
                                disabled={isRequesting || fileList?.length === 0}
                                type='submit'
                                className={`!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 w-40 ${isRequesting || fileList?.length === 0 ? 'button-disabled' : ''}`}
                            >
                                Upload File
                            </button>
                        </div>
                    </FooterModal>
                </form>
            </Modal>
        </>
    )
}

export default UploadFileModal;
